(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6900],{

/***/ 63432:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cookies",
      function () {
        return __webpack_require__(38692);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 38692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ cookies; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
// EXTERNAL MODULE: ./texts/cookies/cookieText.tsx
var cookieText = __webpack_require__(51816);
;// CONCATENATED MODULE: ./texts/cookies/texts.tsx


function getPolicy(lang) {
    switch(lang){
        case "cs":
            return csText();
        case "sk":
            return skText();
        case "uk":
            return ukText();
        case "pl":
            return plText();
        case "en":
        default:
            return enText();
    }
}
function csText() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "Z\xe1sady pou\u017E\xedv\xe1n\xed Cookies"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Spr\xe1vce osobn\xedch \xfadaj\u016F"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Dramox s.r.o., se s\xeddlem na adrese Bucharova 2928/14a, Stod\u016Flky, 158 00 Praha 5, Aspira Business Centre, spole\u010Dnost zapsan\xe1 v obchodn\xedm rejst\u0159\xedku veden\xe9m M\u011Bstsk\xfdm soudem v Praze, odd\xedl C, vlo\u017Eka 332337"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Kontaktn\xed e-mail:",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "mailto:jeviste@dramox.cz",
                        children: " jeviste@dramox.cz"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "C\xedlem t\xe9to str\xe1nky je shrnut\xed z\xe1kladn\xedch informac\xed o cookies vyu\u017E\xedvan\xfdch v\xa0r\xe1mci str\xe1nky www.dramox.cz\xa0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Pou\u017E\xedv\xe1n\xed cookies"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Cookies jsou mal\xe9 textov\xe9 soubory, kter\xe9 str\xe1nka Dramox ukl\xe1d\xe1 do va\u0161eho po\u010D\xedta\u010De. Tyto soubory se pou\u017E\xedvaj\xed k zaji\u0161t\u011Bn\xed chodu nebo efektivn\u011Bj\u0161\xedmu vyu\u017Eit\xed na\u0161ich str\xe1nek a k zaji\u0161t\u011Bn\xed n\u011Bkter\xfdch slu\u017Eeb a funkc\xed pro u\u017Eivatele. Cookies mohou b\xfdt na va\u0161em za\u0159\xedzen\xed ukl\xe1d\xe1ny nebo vyu\u017E\xedv\xe1ny pouze na z\xe1klad\u011B va\u0161eho souhlasu, s v\xfdjimkou soubor\u016F cookie, kter\xe9 jsou nezbytn\u011B nutn\xe9 zaji\u0161t\u011Bn\xed funkce na\u0161ich str\xe1nek. \xda\u010Delem t\xe9to str\xe1nky je poskytnout V\xe1m nezbytn\xe9 informace t\xfdkaj\xedc\xed se pou\u017E\xedv\xe1n\xed cookies a ukl\xe1d\xe1n\xed cookies ve va\u0161em za\u0159\xedzen\xed, abyste se mohli svobodn\u011B rozhodnout, zda chcete umo\u017Enit ulo\u017Een\xed cookies do va\u0161eho za\u0159\xedzen\xed."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Cookies mohou b\xfdt bu\u010F trval\xe9, nebo platn\xe9 po dobu tzv. relace. Trval\xe9 cookies jsou textov\xe9 soubory pos\xedlan\xfd serverem Va\u0161emu internetov\xe9mu prohl\xed\u017Ee\u010Di, kter\xfd pot\xe9, co jej prohl\xed\u017Ee\u010D ulo\u017E\xed, z\u016Fst\xe1v\xe1 platn\xfd a\u017E do nastaven\xe9ho data konce platnosti. Cookies platn\xe9 po dobu relace ztrat\xed platnosti na konci relace u\u017Eivatele pot\xe9, co zav\u0159ete prohl\xed\u017Ee\u010D. \xda\u010Del pou\u017E\xedv\xe1n\xed r\u016Fzn\xfdch cookies je uveden n\xed\u017Ee v t\u011Bchto z\xe1sad\xe1ch."
            }),
            (0,cookieText/* cookieText */.l)("cs"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Zm\u011Bna nastaven\xed cookies v prohl\xed\u017Ee\u010Di"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Zvolte, zda si p\u0159ejete cookies p\u0159ijmout."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Ve v\u011Bt\u0161in\u011B internetov\xfdch prohl\xed\u017Ee\u010D\u016F lze v\xfd\u0161e cookies spravovat v nastaven\xed prohl\xed\u017Ee\u010De. Nastaven\xedm va\u0161eho internetov\xe9ho prohl\xed\u017Ee\u010De se m\u016F\u017Eete p\u0159ij\xedm\xe1n\xed cookies vyhnout. Metoda pou\u017Eit\xe1 k zablokov\xe1n\xed cookies bude z\xe1viset na webov\xe9m prohl\xed\u017Ee\u010Di. N\xe1pov\u011Bdu najdete v prohl\xed\u017Ee\u010Di pod p\u0159\xedslu\u0161nou z\xe1lo\u017Ekou."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            "V\xedce informac\xed o cookies a o tom, jak zjistit, jak\xe9 cookies byly nastaveny a jak je spravovat a odstra\u0148ovat, najdete na internetov\xfdch str\xe1nk\xe1ch ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "http://www.aboutcookies.org",
                                children: "www.aboutcookies.org"
                            }),
                            " a",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "http://www.allaboutcookies.org",
                                children: "www.allaboutcookies.org"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Upozor\u0148ujeme, \u017Ee v p\u0159\xedpad\u011B zm\u011Bny nastaven\xed cookies nemus\xed b\xfdt k dispozici v\u0161echny funkce na\u0161\xed slu\u017Eby."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Pokud cookies nep\u0159ijmete, bude jejich pou\u017E\xedv\xe1n\xed omezeno na nezbytn\xe9 cookies nutn\xe9 k\xa0provozu na\u0161ich str\xe1nek a cookies t\u0159et\xedch stran pro nemarketingov\xe9 \xfa\u010Dely."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Osobn\xed \xfadaje a cookies"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Osobn\xed \xfadaje, kter\xe9 o v\xe1s uchov\xe1v\xe1me, mohou b\xfdt spojeny s vybran\xfdmi cookies."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Z\xe1sady zpracov\xe1n\xed osobn\xedch \xfadaj\u016F p\u0159i pou\u017E\xedv\xe1n\xed cookies"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Tyto Z\xe1sady pou\u017E\xedv\xe1n\xed soubor\u016F cookies tvo\u0159\xed ned\xedlnou sou\u010D\xe1st Z\xe1sad zpracov\xe1n\xed osobn\xedch \xfadaj\u016F na na\u0161ich str\xe1nk\xe1ch, kde najdete ve\u0161ker\xe9 detaily ke zpracov\xe1n\xed osobn\xedch \xfadaj\u016F."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Kontakt"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "V\xa0p\u0159\xedpad\u011B, \u017Ee budete m\xedt k\xa0problematice cookies jak\xe9koli dotazy, nev\xe1hejte n\xe1s kontaktovat:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "E-mail: ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "mailto:jeviste@dramox.cz",
                        children: "jeviste@dramox.cz"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Adresa: Dramox s.r.o., Bucharova 2928/14a, Stod\u016Flky, 158 00 Praha 5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Tato pravidla nab\xfdvaj\xed \xfa\u010Dinnosti dnem 1. 10. 2020."
            })
        ]
    });
}
function skText() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "Z\xe1sady pou\u017E\xedvania Cookies"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Prev\xe1dzkovate\u013E osobn\xfdch \xfadajov"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Dramox s.r.o., so s\xeddlom na adrese Bucharova 2928/14a, Stod\u016Flky, 158 00 Praha 5, Aspira Business Centre, spolo\u010Dnos\u0165 zap\xedsan\xe1 v obchodnom registri vedenom Mestsk\xfdm s\xfadom v Prahe, oddiel C, vlo\u017Eka 332337"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Kontaktn\xfd e-mail:",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "mailto:jeviste@dramox.cz",
                        children: " jeviste@dramox.cz"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Cie\u013Eom tejto str\xe1nky je zhrnutie z\xe1kladn\xfdch inform\xe1ci\xed o s\xfaboroch cookie vyu\u017E\xedvan\xfdch v\xa0 r\xe1mci str\xe1nky www.dramox.sk\xa0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Pou\u017E\xedvanie cookies"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Cookies s\xfa mal\xe9 textov\xe9 s\xfabory, ktor\xe9 str\xe1nka Dramox uklad\xe1 do V\xe1\u0161ho po\u010D\xedta\u010Da. Tieto s\xfabory sa pou\u017E\xedvaj\xfa na zabezpe\u010Denie chodu alebo efekt\xedvnej\u0161ieho vyu\u017Eitia na\u0161ich str\xe1nok a na zabezpe\u010Denie niektor\xfdch slu\u017Eieb a funkci\xed pre u\u017E\xedvate\u013Eov. Cookies m\xf4\u017Eu by\u0165 na Va\u0161om zariaden\xed ukladan\xe9 alebo vyu\u017E\xedvan\xe9 iba na z\xe1klade V\xe1\u0161ho s\xfahlasu, s v\xfdnimkou s\xfaborov cookie, ktor\xe9 s\xfa nevyhnutn\xe9 na zaistenie funkcie na\u0161ich str\xe1nok. \xda\u010Delom tejto str\xe1nky je poskytn\xfa\u0165 V\xe1m nevyhnutn\xe9 inform\xe1cie t\xfdkaj\xface sa pou\u017E\xedvania s\xfaborov cookie a ukladania t\xfdchto s\xfaborov vo Va\u0161om zariaden\xed, aby ste sa mohli slobodne rozhodn\xfa\u0165, \u010Di chcete umo\u017Eni\u0165 ulo\u017Eenie cookies do V\xe1\u0161ho zariadenia."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Cookies m\xf4\u017Eu by\u0165 bu\u010F trval\xe9, alebo platn\xe9 po\u010Das tzv. rel\xe1cie. Trval\xe9 cookies s\xfa textov\xe9 s\xfabory posielan\xe9 serverom V\xe1\u0161mu internetov\xe9mu prehliada\u010Du, ktor\xfd po tom, \u010Do ho prehliada\u010D ulo\u017E\xed, zost\xe1va platn\xfd a\u017E do nastaven\xe9ho d\xe1tumu konca platnosti. S\xfabory cookie platn\xe9 po\u010Das rel\xe1cie stratia platnos\u0165 na konci rel\xe1cie pou\u017E\xedvate\u013Ea po zatvoren\xed prehliada\u010Da. \xda\u010Del pou\u017E\xedvania r\xf4znych s\xfaborov cookie je uveden\xfd ni\u017E\u0161ie v t\xfdchto z\xe1sad\xe1ch."
            }),
            (0,cookieText/* cookieText */.l)("sk"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Zmena nastavenia cookies v prehliada\u010Di"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Zvo\u013Ete, \u010Di si prajete cookies prija\u0165."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Vo v\xe4\u010D\u0161ine internetov\xfdch prehliada\u010Dov je mo\u017En\xe9 vy\u0161\u0161ie uveden\xe9 cookies spravova\u0165 v nastaven\xed prehliada\u010Da. Nastaven\xedm V\xe1\u0161ho internetov\xe9ho prehliada\u010Da sa m\xf4\u017Eete prij\xedmaniu cookies vyhn\xfa\u0165. Met\xf3da pou\u017Eit\xe1 na zablokovanie cookies bude z\xe1visie\u0165 od webov\xe9ho prehliada\u010Da. Pomoc n\xe1jdete v prehliada\u010Di pod pr\xedslu\u0161nou z\xe1lo\u017Ekou."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            "Viac inform\xe1ci\xed o cookies a o tom, ako zisti\u0165, ak\xe9 cookies boli nastaven\xe9 a ako ich spravova\u0165 a odstra\u0148ova\u0165, n\xe1jdete na internetov\xfdch str\xe1nkach ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "http://www.aboutcookies.org",
                                children: "www.aboutcookies.org"
                            }),
                            " a",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "http://www.allaboutcookies.org",
                                children: "www.allaboutcookies.org"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Upozor\u0148ujeme, \u017Ee v pr\xedpade zmeny nastavenia cookies nemusia by\u0165 k dispoz\xedcii v\u0161etky funkcie na\u0161ej slu\u017Eby."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Ak cookies neprijmete, bude ich pou\u017E\xedvanie obmedzen\xe9 na nevyhnutn\xe9 cookies potrebn\xe9 na prev\xe1dzku na\u0161ich str\xe1nok a cookies tret\xedch str\xe1n na nemarketingov\xe9 \xfa\u010Dely."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Osobn\xe9 \xfadaje a cookies"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Osobn\xe9 \xfadaje, ktor\xe9 o V\xe1s uchov\xe1vame, m\xf4\u017Eu by\u0165 spojen\xe9 so s\xfabormi cookie."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Z\xe1sady sprac\xfavania osobn\xfdch \xfadajov pri pou\u017E\xedvan\xed cookies"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Tieto Z\xe1sady pou\u017E\xedvania s\xfaborov cookies tvoria neoddelite\u013En\xfa s\xfa\u010Das\u0165 Z\xe1sad sprac\xfavania osobn\xfdch \xfadajov na na\u0161ich str\xe1nkach, kde n\xe1jdete v\u0161etky detaily o sprac\xfavan\xed osobn\xfdch \xfadajov."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Kontakt"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "V pr\xedpade, \u017Ee budete ma\u0165 k problematike cookies ak\xe9ko\u013Evek ot\xe1zky, nev\xe1hajte n\xe1s kontaktova\u0165:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "E-mail: ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "mailto:jeviste@dramox.cz",
                        children: "jeviste@dramox.cz"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Adresa: Dramox s.r.o., Bucharova 2928/14a, Stod\u016Flky, 158 00 Praha 5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Tieto pravidl\xe1 nadob\xfadaj\xfa \xfa\u010Dinnos\u0165 d\u0148om 01.10.2020."
            })
        ]
    });
}
function enText() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "Cookie Policy"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Personal data controller"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Dramox s.r.o., with its registered office at Bucharova 2928/14a, Stod\u016Flky, 158 00 Prague 5, Aspira Business Centre, a company registered in the Commercial Register kept by the Municipal Court in Prague, Section C, File 332337"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Contact e-mail:",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "mailto:support@dramox.tv",
                        children: " support@dramox.tv"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "The objective of this website is to summarise basic information on cookies used on the website www.dramox.tv"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Using Cookies"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Cookies are small text files stored by dramox website on your computer. These files are used to ensure the operation or more efficient use of our website and to provide users with certain services and features. Cookies may be used or stored on your device only based on your consent, with the exception of cookies that are necessary to ensure proper functioning of our website. The purpose of this website is to provide you with the necessary information concerning the use of cookies and the storage of cookies on your device so that you can freely decide if you want to enable cookies to be stored on your device."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Cookies may be either persistent or session cookies. Persistent cookies are text files sent by the server to your internet browser, which, once stored by the browser, remain valid until the set expiry date. Session cookies will expire at the end of the user\u2019s session after the browser is closed. The purpose of various cookies is specified below in this policy."
            }),
            (0,cookieText/* cookieText */.l)("en"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Changing Your Browser\u2019s Cookie Settings"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Select whether you wish to accept cookies."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "In most internet browsers you can manage your cookies in browser settings. By adjusting your browser settings, you can avoid accepting cookies. The method used to block cookies will depend on the browser. You can find help in the browser under the relevant tab."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            "For more information on cookies and how to determine what cookies have been set up and how to manage and delete them, go to ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "http://www.aboutcookies.org",
                                children: "www.aboutcookies.org"
                            }),
                            " and",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "http://www.allaboutcookies.org",
                                children: "www.allaboutcookies.org"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Please note that in case of a change in the cookies settings, all functions of our service may not be available."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "If you do not accept cookies, their use will be limited to the necessary cookies required for the operation of our website and third-party cookies for non-marketing purposes."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Personal Data and Cookies"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "The personal data we store about you may be associated with selected cookies."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Cookies Policy"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "This Cookies Policy forms an integral part of the Privacy Policy on our website, where you will find all the details on personal data processing."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Contact Details"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Should you have any questions regarding the issue of cookies, do not hesitate to contact us:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "E-mail: ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "mailto:support@dramox.tv",
                        children: "support@dramox.tv"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Address: Dramox s.r.o., Bucharova 2928/14a, Stod\u016Flky, 158 00 Prague 5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "The present rules come into effect on 1 October 2020."
            })
        ]
    });
}
function ukText() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "\u041F\u043E\u043B\u0456\u0442\u0438\u043A\u0430 \u0449\u043E\u0434\u043E \u0444\u0430\u0439\u043B\u0456\u0432 cookie"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "\u041A\u043E\u043D\u0442\u0440\u043E\u043B\u0435\u0440 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0438\u0445 \u0434\u0430\u043D\u0438\u0445"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "\u0422\u041E\u0412 \u0414\u0440\u0430\u043C\u043E\u043A\u0441 (\u0447\u0435\u0441. Dramox s.r.o.), \u0437 \u043C\u0456\u0441\u0446\u0435\u043C \u0437\u043D\u0430\u0445\u043E\u0434\u0436\u0435\u043D\u043D\u044F: \u0432\u0443\u043B. \u0411\u0443\u0445\u0430\u0440\u043E\u0432\u0430 2928/14\u0430, \u0421\u0442\u043E\u0434\u0443\u043B\u043A\u0438, \u043F. \u0456. 158 00, \u041F\u0440\u0430\u0433\u0430 5 (\u0447\u0435\u0441. Bucharova 2928 / 14a, Stod\u016Flky, 158 00 Praha 5), \u0411\u0456\u0437\u043D\u0435\u0441-\u0446\u0435\u043D\u0442\u0440 Aspira (Aspira Business Centre), \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u044F, \u0437\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 \u0442\u043E\u0440\u0433\u043E\u0432\u043E\u043C\u0443 \u0440\u0435\u0454\u0441\u0442\u0440\u0456, \u044F\u043A\u0438\u0439 \u0432\u0435\u0434\u0435\u0442\u044C\u0441\u044F \u0432 \u043C\u0456\u0441\u044C\u043A\u043E\u043C\u0443 \u0441\u0443\u0434\u0456 \u0432 \u041F\u0440\u0430\u0437\u0456, \u0432\u0456\u0434\u0434\u0456\u043B \u0426, \u0432\u043A\u043B\u0430\u0434\u043A\u0430 332337"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u0430 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430 \u043F\u043E\u0448\u0442\u0430:",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "mailto:pidtrymka@dramox.tv",
                        children: " pidtrymka@dramox.tv"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "\u041C\u0435\u0442\u043E\u044E \u0446\u0456\u0454\u0457 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u0454 \u0443\u0437\u0430\u0433\u0430\u043B\u044C\u043D\u0435\u043D\u043D\u044F \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0457 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u0457 \u043F\u0440\u043E \u0444\u0430\u0439\u043B\u0438 cookie, \u044F\u043A\u0456 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u044E\u0442\u044C\u0441\u044F \u043D\u0430 \u0432\u0435\u0431-\u0441\u0430\u0439\u0442\u0456 www.dramox.com.ua"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F \u0444\u0430\u0439\u043B\u0456\u0432 cookie"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "\u0424\u0430\u0439\u043B\u0438 cookie \u2013 \u0446\u0435 \u043D\u0435\u0432\u0435\u043B\u0438\u043A\u0456 \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u0456 \u0444\u0430\u0439\u043B\u0438, \u044F\u043A\u0456 \u0432\u0435\u0431-\u0441\u0430\u0439\u0442 Dramox \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u0454 \u043D\u0430 \u0432\u0430\u0448\u043E\u043C\u0443 \u043A\u043E\u043C\u043F\u2019\u044E\u0442\u0435\u0440\u0456. \u0426\u0456 \u0444\u0430\u0439\u043B\u0438 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u044E\u0442\u044C\u0441\u044F \u0434\u043B\u044F \u0437\u0430\u0431\u0435\u0437\u043F\u0435\u0447\u0435\u043D\u043D\u044F \u0440\u043E\u0431\u043E\u0442\u0438 \u0430\u0431\u043E \u0431\u0456\u043B\u044C\u0448 \u0435\u0444\u0435\u043A\u0442\u0438\u0432\u043D\u043E\u0433\u043E \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F \u043D\u0430\u0448\u043E\u0433\u043E \u0432\u0435\u0431-\u0441\u0430\u0439\u0442\u0443, \u0430 \u0442\u0430\u043A\u043E\u0436 \u0434\u043B\u044F \u043D\u0430\u0434\u0430\u043D\u043D\u044F \u043F\u0435\u0432\u043D\u0438\u0445 \u043F\u043E\u0441\u043B\u0443\u0433 \u0456 \u0444\u0443\u043D\u043A\u0446\u0456\u0439 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430\u043C. \u0424\u0430\u0439\u043B\u0438 cookie \u043C\u043E\u0436\u0443\u0442\u044C \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u0442\u0438\u0441\u044F \u0430\u0431\u043E \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438\u0441\u044F \u043D\u0430 \u0432\u0430\u0448\u043E\u043C\u0443 \u043F\u0440\u0438\u0441\u0442\u0440\u043E\u0457 \u043B\u0438\u0448\u0435 \u0437 \u0432\u0430\u0448\u043E\u0457 \u0437\u0433\u043E\u0434\u0438, \u0437\u0430 \u0432\u0438\u043D\u044F\u0442\u043A\u043E\u043C \u0442\u0438\u0445 \u0444\u0430\u0439\u043B\u0456\u0432 cookie, \u044F\u043A\u0456 \u043D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u0456 \u0434\u043B\u044F \u0437\u0430\u0431\u0435\u0437\u043F\u0435\u0447\u0435\u043D\u043D\u044F \u0444\u0443\u043D\u043A\u0446\u0456\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0456 \u043D\u0430\u0448\u043E\u0433\u043E \u0432\u0435\u0431-\u0441\u0430\u0439\u0442\u0443. \u041C\u0435\u0442\u043E\u044E \u0446\u044C\u043E\u0433\u043E \u0432\u0435\u0431-\u0441\u0430\u0439\u0442\u0443 \u0454 \u043D\u0430\u0434\u0430\u043D\u043D\u044F \u0432\u0430\u043C \u043D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u043E\u0457 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u0457 \u0449\u043E\u0434\u043E \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F \u0444\u0430\u0439\u043B\u0456\u0432 cookie \u0442\u0430 \u0457\u0445\u043D\u044C\u043E\u0433\u043E \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u043D\u043D\u044F \u043D\u0430 \u0432\u0430\u0448\u043E\u043C\u0443 \u043F\u0440\u0438\u0441\u0442\u0440\u043E\u0457, \u0449\u043E\u0431 \u0432\u0438 \u043C\u043E\u0433\u043B\u0438 \u0432\u0456\u043B\u044C\u043D\u043E \u0432\u0438\u0440\u0456\u0448\u0443\u0432\u0430\u0442\u0438, \u0447\u0438 \u0445\u043E\u0447\u0435\u0442\u0435 \u0432\u0438 \u0434\u043E\u0437\u0432\u043E\u043B\u0438\u0442\u0438 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F \u0444\u0430\u0439\u043B\u0456\u0432 cookie \u043D\u0430 \u0432\u0430\u0448\u043E\u043C\u0443 \u043F\u0440\u0438\u0441\u0442\u0440\u043E\u0457."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "\u0424\u0430\u0439\u043B\u0438 cookie \u043C\u043E\u0436\u0443\u0442\u044C \u0431\u0443\u0442\u0438 \u043F\u043E\u0441\u0442\u0456\u0439\u043D\u0438\u043C\u0438 \u0430\u0431\u043E \u0434\u0456\u0439\u0441\u043D\u0438\u043C\u0438 \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C \u0442\u0430\u043A \u0437\u0432\u0430\u043D\u043E\u0457 \u0441\u0435\u0441\u0456\u0457. \u041F\u043E\u0441\u0442\u0456\u0439\u043D\u0456 \u0444\u0430\u0439\u043B\u0438 cookie \u2013 \u0446\u0435 \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u0456 \u0444\u0430\u0439\u043B\u0438, \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u0456 \u0441\u0435\u0440\u0432\u0435\u0440\u043E\u043C \u0443 \u0432\u0430\u0448 \u0456\u043D\u0442\u0435\u0440\u043D\u0435\u0442-\u0431\u0440\u0430\u0443\u0437\u0435\u0440, \u044F\u043A\u0456 \u043F\u0456\u0441\u043B\u044F \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u043E\u043C \u0437\u0430\u043B\u0438\u0448\u0430\u044E\u0442\u044C\u0441\u044F \u0434\u0456\u0439\u0441\u043D\u0438\u043C\u0438 \u0434\u043E \u0432\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043E\u0433\u043E \u0442\u0435\u0440\u043C\u0456\u043D\u0443 \u0434\u0456\u0457. \u0424\u0430\u0439\u043B\u0438 cookie, \u0434\u0456\u0439\u0441\u043D\u0456 \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C \u0441\u0435\u0441\u0456\u0457, \u0441\u0442\u0430\u043D\u0443\u0442\u044C \u043D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u043C\u0438 \u0432 \u043A\u0456\u043D\u0446\u0456 \u0441\u0435\u0441\u0456\u0457 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430 \u043F\u0456\u0441\u043B\u044F \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430. \u041C\u0435\u0442\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F \u0440\u0456\u0437\u043D\u0438\u0445 \u0444\u0430\u0439\u043B\u0456\u0432 cookie \u0437\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0430 \u043D\u0438\u0436\u0447\u0435 \u0432 \u043D\u0430\u0448\u0456\u0439 \u043F\u043E\u043B\u0456\u0442\u0438\u0446\u0456 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F cookie."
            }),
            (0,cookieText/* cookieText */.l)("uk"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "\u0417\u043C\u0456\u043D\u0456\u0442\u044C \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0444\u0430\u0439\u043B\u0456\u0432 cookie \u0432 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0456"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C, \u0447\u0438 \u0445\u043E\u0447\u0435\u0442\u0435 \u0432\u0438 \u043F\u0440\u0438\u0439\u043C\u0430\u0442\u0438 \u0444\u0430\u0439\u043B\u0438 cookie."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "\u0423 \u0431\u0456\u043B\u044C\u0448\u043E\u0441\u0442\u0456 \u0456\u043D\u0442\u0435\u0440\u043D\u0435\u0442-\u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0456\u0432 \u0432\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u043A\u0435\u0440\u0443\u0432\u0430\u0442\u0438 \u0437\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u043C\u0438 \u0432\u0438\u0449\u0435 \u0444\u0430\u0439\u043B\u0430\u043C\u0438 cookie \u0432 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F\u0445 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430. \u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u0432\u0448\u0438 \u0441\u0432\u0456\u0439 \u0456\u043D\u0442\u0435\u0440\u043D\u0435\u0442-\u0431\u0440\u0430\u0443\u0437\u0435\u0440, \u0432\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u0443\u043D\u0438\u043A\u043D\u0443\u0442\u0438 \u043F\u0440\u0438\u0439\u043D\u044F\u0442\u0442\u044F \u0444\u0430\u0439\u043B\u0456\u0432 cookie. \u0421\u043F\u043E\u0441\u0456\u0431 \u0431\u043B\u043E\u043A\u0443\u0432\u0430\u043D\u043D\u044F \u0444\u0430\u0439\u043B\u0456\u0432 cookie \u0437\u0430\u043B\u0435\u0436\u0438\u0442\u044C \u0432\u0456\u0434 \u0432\u0435\u0431-\u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430. \u0412\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u0437\u043D\u0430\u0439\u0442\u0438 \u0434\u043E\u0432\u0456\u0434\u043A\u0443 \u0443 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0456 \u043D\u0430 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u043D\u0456\u0439 \u0432\u043A\u043B\u0430\u0434\u0446\u0456."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            "\u0429\u043E\u0431 \u0437\u043D\u0430\u0439\u0442\u0438 \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0443 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044E \u043F\u0440\u043E \u0444\u0430\u0439\u043B\u0438 cookie \u0442\u0430 \u0449\u043E\u0431 \u0434\u0456\u0437\u043D\u0430\u0442\u0438\u0441\u044F, \u044F\u043A\u0456 \u0444\u0430\u0439\u043B\u0438 cookie \u0431\u0443\u043B\u0438 \u043D\u0430\u043B\u0430\u0448\u0442\u043E\u0432\u0430\u043D\u0456, \u0430 \u0442\u0430\u043A\u043E\u0436 \u044F\u043A \u043D\u0438\u043C\u0438 \u043A\u0435\u0440\u0443\u0432\u0430\u0442\u0438 \u0442\u0430 \u0432\u0438\u0434\u0430\u043B\u044F\u0442\u0438 \u0457\u0445, \u0432\u0456\u0434\u0432\u0456\u0434\u0430\u0439\u0442\u0435 \u0432\u0435\u0431-\u0441\u0430\u0439\u0442\u0438",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "http://www.aboutcookies.org",
                                children: "www.aboutcookies.org"
                            }),
                            " \u0442\u0430",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "http://www.allaboutcookies.org",
                                children: "www.allaboutcookies.org"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "\u0417\u0432\u0435\u0440\u043D\u0456\u0442\u044C \u0443\u0432\u0430\u0433\u0443, \u0449\u043E \u044F\u043A\u0449\u043E \u0432\u0438 \u0437\u043C\u0456\u043D\u0438\u0442\u0435 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0444\u0430\u0439\u043B\u0456\u0432 cookie, \u0442\u043E \u043D\u0435 \u0432\u0441\u0456 \u043D\u0430\u0448\u0456 \u0444\u0443\u043D\u043A\u0446\u0456\u0457 \u0442\u0430 \u043F\u043E\u0441\u043B\u0443\u0433\u0438 \u043C\u043E\u0436\u0443\u0442\u044C \u0431\u0443\u0442\u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0456."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "\u042F\u043A\u0449\u043E \u0432\u0438 \u043D\u0435 \u043F\u0440\u0438\u0439\u043C\u0430\u0454\u0442\u0435 \u0444\u0430\u0439\u043B\u0438 cookie, \u0457\u0445 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F \u0431\u0443\u0434\u0435 \u043E\u0431\u043C\u0435\u0436\u0435\u043D\u043E \u043E\u0431\u043E\u0432\u2019\u044F\u0437\u043A\u043E\u0432\u0438\u043C\u0438 \u0444\u0430\u0439\u043B\u0430\u043C\u0438 cookie, \u043D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u0438\u043C\u0438 \u0434\u043B\u044F \u0440\u043E\u0431\u043E\u0442\u0438 \u043D\u0430\u0448\u043E\u0433\u043E \u0432\u0435\u0431-\u0441\u0430\u0439\u0442\u0443, \u0442\u0430 \u0444\u0430\u0439\u043B\u0430\u043C\u0438 cookie \u0442\u0440\u0435\u0442\u0456\u0445 \u0441\u0442\u043E\u0440\u0456\u043D \u0434\u043B\u044F \u043D\u0435\u043C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433\u043E\u0432\u0438\u0445 \u0446\u0456\u043B\u0435\u0439."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "\u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0456 \u0434\u0430\u043D\u0456 \u0442\u0430 \u0444\u0430\u0439\u043B\u0438 cookie"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "\u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0456 \u0434\u0430\u043D\u0456, \u044F\u043A\u0456 \u043C\u0438 \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u0454\u043C\u043E \u043F\u0440\u043E \u0432\u0430\u0441, \u043C\u043E\u0436\u0443\u0442\u044C \u0431\u0443\u0442\u0438 \u043F\u043E\u0432\u2019\u044F\u0437\u0430\u043D\u0456 \u0437 \u0432\u0438\u0431\u0440\u0430\u043D\u0438\u043C\u0438 \u0444\u0430\u0439\u043B\u0430\u043C\u0438 cookie."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "\u041F\u043E\u043B\u0456\u0442\u0438\u043A\u0430 \u043E\u0431\u0440\u043E\u0431\u043A\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0438\u0445 \u0434\u0430\u043D\u0438\u0445 \u043F\u0440\u0438 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u0456 \u0444\u0430\u0439\u043B\u0456\u0432 cookie"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "\u0426\u044F \u041F\u043E\u043B\u0456\u0442\u0438\u043A\u0430 \u0449\u043E\u0434\u043E \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F \u0444\u0430\u0439\u043B\u0456\u0432 cookie \u0454 \u043D\u0435\u0432\u0456\u0434\u2019\u0454\u043C\u043D\u043E\u044E \u0447\u0430\u0441\u0442\u0438\u043D\u043E\u044E \u041F\u043E\u043B\u0456\u0442\u0438\u043A\u0438 \u043A\u043E\u043D\u0444\u0456\u0434\u0435\u043D\u0446\u0456\u0439\u043D\u043E\u0441\u0442\u0456 \u043D\u0430 \u043D\u0430\u0448\u043E\u043C\u0443 \u0432\u0435\u0431-\u0441\u0430\u0439\u0442\u0456, \u0434\u0435 \u0432\u0438 \u0437\u043D\u0430\u0439\u0434\u0435\u0442\u0435 \u0432\u0441\u0456 \u0434\u0435\u0442\u0430\u043B\u0456 \u043E\u0431\u0440\u043E\u0431\u043A\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0438\u0445 \u0434\u0430\u043D\u0438\u0445."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u0438"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "\u042F\u043A\u0449\u043E \u0443 \u0432\u0430\u0441 \u0432\u0438\u043D\u0438\u043A\u043B\u0438 \u0437\u0430\u043F\u0438\u0442\u0430\u043D\u043D\u044F \u0449\u043E\u0434\u043E \u0444\u0430\u0439\u043B\u0456\u0432 cookie, \u043D\u0435 \u0441\u043E\u0440\u043E\u043C\u0442\u0435\u0441\u044F \u0437\u0432\u0435\u0440\u0442\u0430\u0442\u0438\u0441\u044F \u0434\u043E \u043D\u0430\u0441:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "\u0415\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430 \u043F\u043E\u0448\u0442\u0430: ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "mailto:pidtrymka@dramox.tv",
                        children: "pidtrymka@dramox.tv"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "\u0410\u0434\u0440\u0435\u0441\u0430: Dramox s.r.o., Bucharova 2928 / 14a, Stod\u016Flky, 158 00 Praha 5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "\u0426\u0456 \u043F\u0440\u0430\u0432\u0438\u043B\u0430 \u043D\u0430\u0431\u0438\u0440\u0430\u044E\u0442\u044C \u0447\u0438\u043D\u043D\u043E\u0441\u0442\u0456 1 \u0436\u043E\u0432\u0442\u043D\u044F 2020 \u0440\u043E\u043A\u0443."
            })
        ]
    });
}
function plText() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "Polityka plik\xf3w cookies (\u201EPolityka\u201D)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Administrator danych osobowych:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Dramox s.r.o., z siedzib\u0105 w Pradze, adres: Bucharova 2928/14a, Stod\u016Flky, 158 00 Praga 5, Aspira Business Centre, Republika Czeska, sp\xf3\u0142ka z ograniczon\u0105 odpowiedzialno\u015Bci\u0105 zarejestrowana w Rejestrze Handlowym prowadzonym przez S\u0105d Miejski w Pradze, dzia\u0142 C, plik 332337 (\u201E",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "Administrator"
                    }),
                    "\u201C)"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "adres e-mail: ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "mailto:sufler@dramox.pl",
                        children: "sufler@dramox.pl"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Celem Polityki jest podsumowanie najwa\u017Cniejszych informacji o plikach cookies (tzw. \u201Eciasteczkach\u201D) wykorzystywanych na stronie: ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.dramox.pl",
                        children: "www.dramox.pl"
                    }),
                    " (\u201E",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "Portal"
                    }),
                    "\u201C)."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Wykorzystanie plik\xf3w cookies"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Pliki cookies to ma\u0142e pliki tekstowe, kt\xf3re Portal zapisuje na Twoim komputerze. Pliki te s\u0105 wykorzystywane w celu zapewnienia odpowiedniego dzia\u0142ania lub bardziej efektywnego korzystania z Portalu oraz \u015Bwiadczenia niekt\xf3rych us\u0142ug i oferowania funkcji naszym u\u017Cytkownikom. Pliki cookies mog\u0105 by\u0107 przechowywane lub wykorzystywane na Twoim urz\u0105dzeniu wy\u0142\u0105cznie za Twoj\u0105 zgod\u0105, z wyj\u0105tkiem niezb\u0119dnych plik\xf3w cookies, kt\xf3re zapewniaj\u0105 funkcjonowanie Portalu. Celem Polityki jest dostarczenie Ci wszelkich istotnych informacji dotycz\u0105cych korzystania z plik\xf3w cookies i przechowywania plik\xf3w cookies na Twoim urz\u0105dzeniu, aby\u015B m\xf3g\u0142 swobodnie decydowa\u0107, czy chcesz zezwoli\u0107 na takie przechowywanie."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Pliki cookies mog\u0105 by\u0107 sta\u0142e lub wa\u017Cne tylko na czas trwania sesji (tymczasowe). Sta\u0142e pliki cookies to pliki tekstowe wysy\u0142ane przez serwer do Twojej przegl\u0105darki internetowej, kt\xf3re po zapisaniu przez przegl\u0105dark\u0119 zachowuj\u0105 wa\u017Cno\u015B\u0107 do ustawionej daty wa\u017Cno\u015Bci. Tymczasowe pliki cookies wygasaj\u0105 wraz z zako\u0144czeniem sesji u\u017Cytkownika po zamkni\u0119ciu przegl\u0105darki. Cele korzystania z r\xf3\u017Cnych plik\xf3w cookies s\u0105 okre\u015Blone poni\u017Cej."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Niezb\u0119dne pliki cookies wyst\u0119puj\u0105ce na Portalu"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Niekt\xf3re pliki cookies, kt\xf3rych u\u017Cywamy, s\u0105 niezb\u0119dne do \u015Bwiadczenia us\u0142ug w ramach Portalu. Je\u015Bli wy\u0142\u0105czysz takie pliki cookies w ustawieniach swojej przegl\u0105darki, nie b\u0119dziesz m\xf3g\u0142 korzysta\u0107 z Portalu i us\u0142ug z nim zwi\u0105zanych. U\u017Cywane przez nas pliki cookies na stronach internetowych \u2013 w tym na Portalu - oraz powody ich u\u017Cywania s\u0105 wymienione poni\u017Cej. Nale\u017Cy pami\u0119ta\u0107, \u017Ce pliki cookies opisane w Polityce s\u0105 u\u017Cywane na wszystkich platformach, za po\u015Brednictwem kt\xf3rych dost\u0119pne s\u0105 nasze us\u0142ugi."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                children: "Funkcjonalne pliki cookies"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Typ pliku: Sta\u0142y"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Cel: zapewnienie odpowiedniej funkcjonalno\u015Bci strony internetowej"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Funkcja: Pomagaj\u0105 zidentyfikowa\u0107 Tw\xf3j komputer, je\u015Bli wr\xf3cisz na nasz\u0105 stron\u0119 internetow\u0105 (Portal). Pozwalaj\u0105 dostosowa\u0107 Portal do Twoich potrzeb."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Wa\u017Cno\u015B\u0107: 1 rok"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                children: "Zewn\u0119trzne pliki cookies (analityczne)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Pliki cookies tego rodzaju s\u0105 umieszczane przez osoby trzecie, a nie przez Portal. Te pliki cookies mog\u0105 by\u0107 u\u017Cywane tylko za Twoj\u0105 uprzedni\u0105 zgod\u0105."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                children: "Hotjar"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Typ pliku: Sta\u0142y"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Cel: Analiza/pomiar"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Funkcja: Hotjar wykorzystuje okre\u015Blone pliki cookies w celu identyfikacji odwiedzaj\u0105cych, oceny wzorc\xf3w zachowa\u0144 i analizy ruchu u\u017Cytkownik\xf3w."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Wa\u017Cno\u015B\u0107: 1 rok"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                children: "Google Analytics"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Typ pliku: Sta\u0142y"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Cel: Analiza/pomiar"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Funkcja: Google u\u017Cywa plik\xf3w cookies do zbierania statystyk online i \u015Bledzenia wsp\xf3\u0142czynnik\xf3w konwersji."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Wa\u017Cno\u015B\u0107: 2 lata"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                children: "Google Tag Manager"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Typ pliku: Sta\u0142y"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Cel: Analiza/pomiar"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Funkcja: Google u\u017Cywa plik\xf3w cookies do zbierania statystyk online i \u015Bledzenia wsp\xf3\u0142czynnik\xf3w konwersji."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Wa\u017Cno\u015B\u0107: 1-20 lat"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Reklamowe pliki cookies"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Te pliki cookies wykorzystywane s\u0105 w celach marketingowych. S\u0105 one umieszczane przez osoby trzecie, a nie przez Portal. Mo\u017Cesz wy\u0142\u0105czy\u0107 takie pliki cookies w dowolnym momencie w ustawieniach przegl\u0105darki \u2013 zgodnie z poni\u017Cszym opisem. Zablokowanie tych plik\xf3w cookies nie wp\u0142ynie na dzia\u0142anie Portalu."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                children: "Google Ads"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Typ pliku: Sta\u0142y"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Cel: wy\u015Bwietlanie reklam/targetowanie"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Funkcja: Witryny u\u017Cywaj\u0105 tych plik\xf3w cookies do mierzenia skuteczno\u015Bci swoich kampanii marketingowych online."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Wa\u017Cno\u015B\u0107: 1 rok"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                children: "Facebook"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Typ pliku: Sta\u0142y"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Cel: wy\u015Bwietlanie reklam/targetowanie"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Funkcja: Witryny u\u017Cywaj\u0105 tych plik\xf3w cookies do mierzenia skuteczno\u015Bci swoich kampanii marketingowych online."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Wa\u017Cno\u015B\u0107: 1 rok"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                children: "Sklik"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Typ pliku: Sta\u0142y"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Cel: wy\u015Bwietlanie reklam/targetowanie"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Funkcja: Witryny u\u017Cywaj\u0105 tych plik\xf3w cookies do mierzenia skuteczno\u015Bci swoich kampanii marketingowych online."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Wa\u017Cno\u015B\u0107: 1 rok"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                children: "Google Remarketing"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Typ pliku: Sta\u0142y"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Cel: wy\u015Bwietlanie reklam/targetowanie"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Funkcja: Witryny u\u017Cywaj\u0105 tych plik\xf3w cookies do mierzenia skuteczno\u015Bci swoich kampanii marketingowych online."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Wa\u017Cno\u015B\u0107: 1 rok"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Zmiana ustawie\u0144 dot. plik\xf3w cookies w przegl\u0105darce"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Wybierz, czy akceptujesz pliki cookies poprzez wyb\xf3r odpowiedniej opcji przedstawionej na Portalu i dostosowanie ustawie\u0144."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "W przypadku wi\u0119kszo\u015Bci przegl\u0105darek internetowych w\u0142\u0105czaniem i wy\u0142\u0105czaniem plik\xf3w cookies mo\u017Cna zarz\u0105dza\u0107 za pomoc\u0105 ustawie\u0144 przegl\u0105darki. Spos\xf3b wy\u0142\u0105czenia plik\xf3w cookies zale\u017Cy od przegl\u0105darki internetowej. Pomoc znajdziesz w swojej przegl\u0105darce w odpowiedniej zak\u0142adce."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            "Wi\u0119cej informacji na temat zarz\u0105dzania plikami cookies oraz zmiany ustawie\u0144 dotycz\u0105cych plik\xf3w cookies mo\u017Cna znale\u017A\u0107 na stronach: ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.aboutcookies.org",
                                children: "www.aboutcookies.org"
                            }),
                            " oraz",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.allaboutcookies.org",
                                children: "www.allaboutcookies.org"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Nale\u017Cy pami\u0119ta\u0107, \u017Ce w przypadku zmiany ustawie\u0144 dotycz\u0105cych plik\xf3w cookies nie wszystkie funkcje Portalu mog\u0105 by\u0107 dost\u0119pne."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Je\u015Bli nie akceptujesz plik\xf3w cookies, ich u\u017Cycie b\u0119dzie ograniczone do niezb\u0119dnych plik\xf3w cookies, kt\xf3re s\u0105 wymagane do dzia\u0142ania Portalu oraz plik\xf3w cookies os\xf3b trzecich wykorzystywanych w celach niemarketingowych."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Dane osobowe i pliki cookies"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Twoje dane osobowe, kt\xf3re przechowujemy, mog\u0105 by\u0107 powi\u0105zane z wybranymi plikami cookies."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Zasady przetwarzania danych osobowych podczas korzystania z plik\xf3w cookies"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Niniejsza Polityka stanowi integraln\u0105 cz\u0119\u015B\u0107 Polityki Prywatno\u015Bci Portalu, w kt\xf3rej znajdziesz wszystkie szczeg\xf3\u0142y dotycz\u0105ce przetwarzania danych osobowych."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Dane kontaktowe"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Je\u017Celi masz jakiekolwiek pytania dotycz\u0105ce plik\xf3w cookies, skontaktuj si\u0119 z nami:",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "E-mail:"
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "mailto:sufler@dramox.pl",
                        children: "sufler@dramox.pl"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "Adres:"
                    }),
                    " Dramox s.r.o., Bucharova 2928 / 14a, Stod\u016Flky, 158 00 Praga 5, Republika Czeska"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Polityka wchodzi w \u017Cycie z dniem: 1.11.2022."
            })
        ]
    });
}

// EXTERNAL MODULE: ./enums/namespaces.ts
var namespaces = __webpack_require__(99731);
// EXTERNAL MODULE: ./helpers/jsx.tsx
var jsx = __webpack_require__(28808);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(62044);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(1984);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./components/Layout/index.tsx + 12 modules
var Layout = __webpack_require__(46323);
// EXTERNAL MODULE: ./pages/cookies/index.module.scss
var index_module = __webpack_require__(58977);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./pages/cookies/index.tsx









var Cookies = function(param) {
    var countryCode = param.countryCode;
    var ref = (0,useTranslation/* default */.Z)(namespaces/* Namespace.Common */.l.Common), lang = ref.lang, t = ref.t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        countryCode: countryCode,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
            className: (index_module_default()).legal,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                    children: (0,jsx/* basicSEO */.F)(t("seo:cookies_title"), t("seo:cookies_description"))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (index_module_default()).updated,
                    children: t("cookie_updated")
                }),
                getPolicy(lang)
            ]
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var cookies = (Cookies);


/***/ }),

/***/ 58977:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"legal":"cookies_legal__OriRG"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1816,9774,2888,179], function() { return __webpack_exec__(63432); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);